/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function initTierModel(model: any): void {
  model.minimumTraffic = model.minimumTraffic || 100;
  model.maximumTraffic = model.maximumTraffic || 100;
  model.type = model.type || 'STANDARD';
}

export function isTierEnabled(tierId: string, network: any): boolean {
  return _.some(network?.tiers, ['id', tierId]);
}

export function decorateTiersWithNetworkState(tiers: any[], network: any): any[] {
  const indexedTiers = _.keyBy(network?.tiers, 'id');
  return _.map(tiers, (tier) => {
    const enabled = !!indexedTiers[tier.id];
    const idx = _.findIndex(network?.tiers, ['id', tier.id]);
    return {
      ...tier,
      enabled,
      pos: enabled ? (idx + 1) : 999
    };
  });
}
